import { CrowdtapEnvironment } from './definition';

export const environment: CrowdtapEnvironment = {
  production: false,
  preview: false,
  global: true,
  emergency: false,
  local: false,
  externalLink: false,
  apiUrl: 'https://dev-api.asksuzy.com/dev-member',
  globalUrl: 'https://isolate-qa.asksuzy.io/api',
  signalRUrl: 'https://ws-dev.asksuzy.io',
  facebookAppId: 'xxxxxxxxxx',
  grecaptchaToken: '6LcaClsaAAAAAJWoziDMD8F3PhE9XyQFRTzMj1zK',
  grecaptchaV2Token: '6LfkEVsaAAAAAP4uRsbnzOilVnPTAPKaR6PK7P2i',
  languagePlatform: 'crowdtap.v1',
  segmentToken: 'zCtsiCV6Em2I4aJWDRvBRHEl8mXXcnK6',
  sharedLinkRoot: 'https://preview-qa.suzy.com/preview',
  launchDarkly: '62c593e3a9ccc815c757b908',
  legalId: '1248700B-3E07-48DF-9427-1885E1FE8213',
  verisoulBundleUri: undefined,
  verisoulProjectId: undefined
};
